import { render, staticRenderFns } from "./ResolveAction.vue?vue&type=template&id=7081d5fb&scoped=true&"
import script from "./ResolveAction.vue?vue&type=script&lang=js&"
export * from "./ResolveAction.vue?vue&type=script&lang=js&"
import style0 from "./ResolveAction.vue?vue&type=style&index=0&id=7081d5fb&lang=scss&scoped=true&"
import style1 from "./ResolveAction.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081d5fb",
  null
  
)

export default component.exports